import * as aor from "react-admin";
import React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import UploaderToolButton from "../../components/UploaderToolButton";

import { POLICY_UTILITIES } from "../../common/rolesManagement";
import DownloadUtilityButton from "../../components/DownloadUtilityButton";

const cardStyle = {
    height: "100%",
    width: 300,
    minHeight: 300,
    margin: "0.5em",
    display: "inline-block",
    verticalAlign: "top"
};

const cardMediaStyle = {
    maxWidth: 345,
    height: 140
};

const FILE_MIME_TYPE = "application/x-7z-compressed, .7z";

class MyCard extends React.Component {
    state = {
        url: this.props.url
    };

    updateUrl(url) {
        this.setState({ url: url });
    }

    render() {
        return (
            <Card key={this.props.id} style={cardStyle}>
                <CardMedia
                    style={cardMediaStyle}
                    image={this.props.image_path}
                    title={this.props.title}
                />
                <CardHeader title={this.props.title} />
                <CardContent>
                    <aor.TextField
                        record={{ description: this.props.description }}
                        source="description"
                    />
                </CardContent>
                <CardActions>
                    <DownloadUtilityButton
                        id={this.props.id}
                        url={this.state.url || this.props.url}
                    />
                    {this.props.permissions &&
                        this.props.permissions.includes(
                            POLICY_UTILITIES.UPLOAD
                        ) && (
                            <UploaderToolButton
                                key={`uploader_button_${this.props.id}`}
                                id={this.props.id}
                                file_mime_type={
                                    this.props.file_mime_type || FILE_MIME_TYPE
                                }
                                updateUrlFunction={this.updateUrl.bind(this)}
                            />
                        )}
                </CardActions>
            </Card>
        );
    }
}

const UtilitiesGrid = ({ ids, data, basePath, permissions }) => (
    <div style={{ margin: "1em" }}>
        {ids.map(id => (
            <MyCard
                key={id}
                permissions={permissions}
                // id={id}
                // data={data[id]}
                // image={data[id].image_path}
                // title={data[id].title}
                {...data[id]}
            />
        ))}
    </div>
);

UtilitiesGrid.defaultProps = {
    data: {},
    ids: []
};

export default ({ permissions, ...props }) => (
    <aor.List
        actions={null}
        pagination={null}
        title="resources.utilities.nameSingular"
        {...props}
    >
        <UtilitiesGrid permissions={permissions} />
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/Utilities/List.js